/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Button, InputGroup, Row, Col,
} from 'reactstrap';

import {
  Field, FormikConsumer, ErrorMessage,
} from 'formik';

function AttributesFieldset(props) {
  const { arrayHelpers, t, suggestedFields } = props;

  const handleAddAttribute = (label = '') => {
    arrayHelpers.push({ label, code: '' });
  };

  const jsx = (
    <FormikConsumer>
      {({
        // eslint-disable-next-line no-unused-vars
        touched, errors, values, setFieldValue,
      }) => (
        <div>

          {suggestedFields
            .map((attribute) => (
              <div>
                <Button color="primary" onClick={() => handleAddAttribute(attribute)} className="btn-sm mt-1 mb-1">
                  <span className="bx bx-plus" />
                  {props.t(`Add ${attribute}`)}
                </Button>
              </div>
            ))}
          <Button color="primary" onClick={() => handleAddAttribute()} className="btn-sm mt-1 mb-3">
            <span className="bx bx-plus" />
            {props.t('Add Attribute')}
          </Button>

          {errors.attributes !== undefined && typeof errors.attributes === 'string' && (
            <ErrorMessage
              name="attributes"
              component="div"
              className="alert alert-danger fade show mt-2 mb-3"
            />
          )}
          {values.attributes.map((attribute, index) => (
            <div key={index}>
              <Row className="mb-3">
                <Col xs="6">
                  <Field name={`attributes[${index}].label`} type="text" className="form-control" placeholder={t('Label')} />
                  <ErrorMessage
                    name={`attributes[${index}].label`}
                    component="div"
                    className="text-danger pt-1"
                  />
                </Col>

                <Col xs="6">
                  <InputGroup>
                    <Field name={`attributes[${index}].code`} type="text" onKeyUp={(e) => { setFieldValue(`attributes[${index}].code`, e.target.value); }} className="form-control" placeholder={t('Value')} />
                    <Button
                      type="button"
                      onClick={() => arrayHelpers.remove(index)}
                      color="danger"
                      className="btn-soft-danger"
                    >
                      <span className="mdi mdi-close-thick" />
                    </Button>
                  </InputGroup>
                  <ErrorMessage
                    name={`attributes[${index}].code`}
                    component="div"
                    className="text-danger pt-1"
                  />
                </Col>
              </Row>
            </div>
          ))}
        </div>
      )}
    </FormikConsumer>
  );

  return jsx;
}

AttributesFieldset.defaultProps = {
  t: (x) => (x),
};

AttributesFieldset.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  suggestedFields: PropTypes.arrayOf(PropTypes.string).isRequired,
  arrayHelpers: PropTypes.object.isRequired,
};

export default connect(() => ({

}), {})(withTranslation()(AttributesFieldset));
